<template>
  <div>
    <v-layout row wrap>
      <v-flex md12>
        <h2>Settings</h2>
        <v-card>
          <v-card-text>
            <v-text-field label="Last Quotation No" v-model="last_quotation_no" />
            <v-text-field label="Last Invoice No" v-model="last_invoice_no" />
            <v-btn color="primary" @click.stop="save">Save</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      bottom
      color="success"
      multi-line
      :timeout="2000"
    >
      Saved!
    </v-snackbar>
  </div>
</template>

<script type="text/javascript">
  export default {
    data () {
      return {
        last_quotation_no: 1,
        last_invoice_no: 1,
        snackbar: false
      }
    },
    methods: {
      async save () {
        const apiUrl = this.$store.getters.config.api_host
        const data = {
          id: 1,
          last_quotation_no: this.last_quotation_no,
          last_invoice_no: this.last_invoice_no
        }
        const response = await this.$axios.post(`${apiUrl}/api/settings`, data)
        if (response) {
          this.snackbar = true
        }
      }
    },
    created () {
      const apiUrl = this.$store.getters.config.api_host
      this.$axios.get(`${apiUrl}/api/settings`).then(response => {
        this.last_invoice_no = response.data.additional_data[0].last_invoice_no
        this.last_quotation_no = response.data.additional_data[0].last_quotation_no
      })
    }
  }
</script>

<style scoped>
  h2 {
    text-transform: uppercase;
    font-weight: normal;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    padding-bottom: 10px;
    position: relative;
    font-size: 18px;
  }
  h2:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #fff;
    position: absolute;
    bottom: -2px;
  }
</style>



// WEBPACK FOOTER //
// Settings.vue?3da0732e